// extracted by mini-css-extract-plugin
export default {"sets":"Sets_sets__gHURk","quality":"Sets_quality__hy626","line":"Sets_line__77NjK"};